import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import apiClient from '../../Api/axiosConfig';
import { useNavigate } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await apiClient.post('/auth/logout');
      logout();
      navigate('/admin/login');
    } catch (err) {
      console.error('Hiba a kijelentkezés során.');
    }
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <h1 className="admin-logo">LRP ADMIN</h1>
        <nav className="admin-nav">
          <NavLink to="/admin" end>Áttekintés</NavLink>
          <NavLink to="/admin/global">Globális Beállítások</NavLink>
          <NavLink to="/admin/social">Közösségi Média</NavLink>
          <NavLink to="/admin/praises">Dicséretek</NavLink>
          <NavLink to="/admin/author">Szerzői Oldal</NavLink>
          <NavLink to="/admin/books">Könyvek Kezelése</NavLink>
          <hr style={{width: '100%'}}/>
          <NavLink to="/admin/analytics">Analitika</NavLink>
        </nav>
        <div className="admin-sidebar-footer">
          <button onClick={handleLogout} className="logout-button">Kijelentkezés</button>
        </div>
      </aside>
      <main className="admin-main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;